import React from "react";
import { Button, Divider, Form, Input, Modal, Space } from "antd";
import ChecklistItemsEditor from "./ChecklistItemsEditor";

// Create / edit a reusable checklist template. Templates live in the
// `checklistTemplates` collection and can be applied to any property.
const ChecklistTemplateModal = ({
  open,
  onCancel,
  form,
  onValuesChange,
  onFinish,
  onFinishFailed,
  questionaire,
  setQuestionaire,
  handleAddQuestion,
  handleAddProblem,
  handleAddResolutionStep,
  handleRemoveResolutionStep,
  isEditing,
  isloading,
}) => {
  return (
    <Modal
      title={
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 12,
            // Leave room for the modal's close (X) button at the far right.
            paddingRight: 28,
          }}
        >
          <span>{isEditing ? "Edit Checklist" : "Create Checklist"}</span>
          <Space>
            <Button size="small" onClick={onCancel}>
              Cancel
            </Button>
            <Button
              size="small"
              type="primary"
              loading={isloading}
              onClick={() => form.submit()}
            >
              {isEditing ? "Save Changes" : "Save Checklist"}
            </Button>
          </Space>
        </div>
      }
      open={open}
      onCancel={onCancel}
      footer={null}
      width={850}
      style={{ top: 20 }}
      // Scroll the body so the sticky action bar stays pinned at the top no
      // matter how long the checklist gets.
      styles={{ body: { maxHeight: "78vh", overflowY: "auto", paddingTop: 12 } }}
      destroyOnClose
      maskClosable={false}
      keyboard={false}
    >
      <Form
        form={form}
        layout="vertical"
        onValuesChange={onValuesChange}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Form.Item
          label="Checklist Name"
          name="name"
          rules={[
            { required: true, message: "Checklist name is required" },
            { max: 60, message: "Name must be max 60 characters" },
          ]}
        >
          <Input maxLength={60} placeholder="e.g. Standard 3BR Residential" />
        </Form.Item>

        <Form.Item label="Description (optional)" name="description">
          <Input.TextArea
            autoSize={{ minRows: 2 }}
            maxLength={200}
            placeholder="When should this checklist be used?"
          />
        </Form.Item>

        <Divider orientation="left">Checklist Items</Divider>
        <ChecklistItemsEditor
          questionaire={questionaire}
          setQuestionaire={setQuestionaire}
          handleAddQuestion={handleAddQuestion}
          handleAddProblem={handleAddProblem}
          handleAddResolutionStep={handleAddResolutionStep}
          handleRemoveResolutionStep={handleRemoveResolutionStep}
        />

        <Divider />
        <Form.Item>
          <Space>
            <Button type="primary" htmlType="submit" loading={isloading}>
              {isloading
                ? "Saving..."
                : isEditing
                ? "Save Changes"
                : "Save Checklist"}
            </Button>
            <Button onClick={onCancel}>Cancel</Button>
          </Space>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ChecklistTemplateModal;
